import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Stack, TextField, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AuthContext } from "../../contexts/AuthContext";
import { getGroupEmail } from "../../helpers/authUser";
import theme from "../../theme";
import MailIcon from '@mui/icons-material/MailOutline';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        height: 'fit-content',
        padding: 16,
        borderRadius: 8,
        border: '1px solid #d9fdf5',
        background: '#f1fdfb',
    },
    subText: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#18222d',
    },
    menuIcon: {
        width: 24,
        height: 24,
        fill: '#048290',
    },
    textField: {
        width: '100%',
        margin: 0,
        '& .MuiOutlinedInput-root': {
          width: '100%',
          height: '40px',
          background: '#fff',
          '& fieldset': {
            transition: 'border-color 0.3s ease',
          },
          '&.Mui-disabled': {
            '& > input': {
              fontFamily: 'Lato',
              fontSize: '1rem',
              fontWeight: 600,
              color: `${theme.palette.primary.main} !important`,
              WebkitTextFillColor: `${theme.palette.primary.main} !important`, // ensures color override in disabled state
            },
            '& fieldset': {
              borderColor: '#d9fdf5 !important',
            },
          },
        },
      },
}));

const ForwardDealsModern: React.FC<{}> = () => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { userGroup } = useContext(AuthContext);

    return (<>
        <Stack direction="column" className={classes.container} spacing={1} alignItems="flex-start">
            <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="flex-start">
                <MailIcon className={classes.menuIcon} />
                <Typography className={classes.subText}>
                    {'Forward companies to: '}
                </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%" pl={4}>
                <TextField variant="outlined"
                    className={classes.textField}
                    value={getGroupEmail(userGroup)}
                    disabled />
                <CopyToClipboard text={`${getGroupEmail(userGroup)}`}
                    options={{ format: "text/plain" }}
                    onCopy={() => {
                        enqueueSnackbar(`Successfully copied to clipboard.`,
                            { anchorOrigin: { vertical: "bottom", horizontal: "right" }, });
                    }}>
                    <IconButton size="small" sx={{ color: theme.colors.cyan['500'] }} disableRipple>
                        <ContentCopyIcon sx={{ width: 20, height: 20, }} />
                    </IconButton>
                </CopyToClipboard>
            </Stack>
        </Stack>
    </>);
}

export default ForwardDealsModern;
